import { render, staticRenderFns } from "./loaddingCom.vue?vue&type=template&id=ea1a359a&scoped=true"
import script from "./loaddingCom.vue?vue&type=script&lang=js"
export * from "./loaddingCom.vue?vue&type=script&lang=js"
import style0 from "./loaddingCom.vue?vue&type=style&index=0&id=ea1a359a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea1a359a",
  null
  
)

export default component.exports